import LogoTecno from "../../tecnologo.png";
import React from "react";
import Alert from "../ui/feedback/Alert";

const ResetComponent = (props) => {
  return (
    <div className="w-full sm:max-w-lg sm:rounded-lg">
      {props.component.state.status}
      <div className="w-full px-16 py-16 mt-6 overflow-hidden bg-white shadow-md">
        <form
          method="POST"
          onSubmit={(event) => {
            props.component.resetPassword();
            event.preventDefault();
          }}
        >
          <div>
            <div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">
                  Reimposta la password
                </h3>

                <p className="block py-6 font-medium text-gray-600">
                  Inserisci l'indirizzo email o il nome utente associato al tuo
                  account e ti invieremo un link per reimpostare la password.
                </p>
              </div>

              <label
                htmlFor="name"
                className="block text-sm bold font-medium text-gray-700 undefined"
              >
                Nome utente o Email
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="text"
                  name="username"
                  className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-green-300 focus:ring focus:ring-green-200 focus:ring-opacity-50"
                  onChange={(event) =>
                    props.component.setState({ username: event.target.value })
                  }
                />
              </div>
            </div>
            <div className="flex flex-wrap items-center mt-4">
              <button
                type="submit"
                className="w-full my-2 px-4 py-2 tracking-wide text-white bg-gradient-to-r from-green-500 to-green-700 rounded-md hover:bg-green-600 focus:outline-none focus:bg-green-600"
              >
                Continua
              </button>
            </div>
          </div>
        </form>
        <div className="flex items-center w-full my-4">
          <hr className="w-full" />
        </div>
      </div>
    </div>
  );
};

const ContactComponent = (props) => {
  return (
    <div className="w-full sm:max-w-lg sm:rounded-lg">
      {props.component.state.status}
      <div className="w-full px-16 py-16 mt-6 overflow-hidden bg-white shadow-md">
        <form
          method="POST"
          onSubmit={(event) => {
            props.component.contact();
            event.preventDefault();
          }}
        >
          <div>
            <div>
              <div>
                <h3 className="text-2xl font-bold text-gray-900">
                  Contattaci per resettare la password
                </h3>

                <p className="block py-6 font-medium text-gray-600">
                  Inserisci le informazioni richieste e verrai ricontattato
                  quanto prima per aiutarti a resettare la password.
                </p>
              </div>

              <label
                htmlFor="name"
                className="block text-sm mt-3 bold font-medium text-gray-700 undefined"
              >
                Nome utente
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="text"
                  name="username"
                  className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-green-300 focus:ring focus:ring-green-200 focus:ring-opacity-50"
                  onChange={(event) =>
                    props.component.setState({ username: event.target.value })
                  }
                />
              </div>

              <label
                htmlFor="email"
                className="block text-sm mt-3 bold font-medium text-gray-700 undefined"
              >
                Email
              </label>
              <div className="flex flex-col items-start">
                <input
                  type="text"
                  name="email"
                  className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-green-300 focus:ring focus:ring-green-200 focus:ring-opacity-50"
                  onChange={(event) =>
                    props.component.setState({ email: event.target.value })
                  }
                />
              </div>

              <label
                htmlFor="desc"
                className="block text-sm mt-3 bold font-medium text-gray-700 undefined"
              >
                Informazioni aggiuntive
              </label>
              <div className="flex flex-col items-start">
                <textarea
                  name="desc"
                  className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:border-green-300 focus:ring focus:ring-green-200 focus:ring-opacity-50"
                  onChange={(event) =>
                    props.component.setState({ message: event.target.value })
                  }
                />
              </div>
            </div>
            <div className="flex flex-wrap items-center mt-4">
              <button
                type="submit"
                className="w-full my-2 px-4 py-2 tracking-wide text-white bg-gradient-to-r from-green-500 to-green-700 rounded-md hover:bg-green-600 focus:outline-none focus:bg-green-600"
              >
                Continua
              </button>
            </div>
          </div>
        </form>

        <div className="flex items-center w-full my-4">
          <hr className="w-full" />
        </div>
      </div>
    </div>
  );
};

export default class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      email: "",
      message: "",
    };
  }

  obscureEmail(email) {
    const [name, domain] = email.split("@");
    return `${name[0]}${new Array(name.length - 1).join("*")}${
      name[name.length - 1]
    }@${domain}`;
  }

  async resetPassword() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "http://localhost:3000",
      },
      body: JSON.stringify({
        username: this.state.username,
      }),
    };

    await fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        "/passwordreset/request",
      requestOptions
    )
      .then(async (response) => await response.json())
      .then((data) => {
        if (data.status === "UNKNOWN_USER") {
          this.setState({
            status: (
              <Alert
                color="red"
                header="Utente inesistente"
                description="Non è stato trovato nessun utente con questi dati!"
              />
            ),
          });
          return;
        }

        if (data.status === "INVALID_EMAIL") {
          this.setState({
            status: (
              <Alert
                color="red"
                header="Email inesistente!"
                description="Non abbiamo nessuna e-mail di contatto salvata per questo utente,
                                       clicca il bottone arancione per contattarci!"
              />
            ),
          });
          return;
        }

        if (data.status === "WAIT_TIMEOUT") {
          this.setState({
            status: (
              <Alert
                color="red"
                header="Timeout di attesa"
                description="Hai già inviato una richiesta negli ultimi 10 minuti, aspetta!"
              />
            ),
          });
          return;
        }

        if (data.success === null) {
          this.setState({
            status: (
              <Alert
                color="red"
                header="Errore interno!"
                description="C'è stato un errore interno, riprova!"
              />
            ),
          });
          return;
        }

        this.setState({
          status: (
            <Alert
              color="green"
              header="Richiesta inviata"
              description={
                "Hai inviato la richiesta con successo, controlla la tua mail all'indirizzo " +
                this.obscureEmail(data.sentTo)
              }
            />
          ),
        });
      })
      .then(() => this.setState({ form: <ResetComponent component={this} /> }));
  }

  async contact() {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "http://localhost:3000",
      },
      body: JSON.stringify({
        username: this.state.username,
        email: this.state.email,
        message: this.state.message,
      }),
    };

    if (!this.state.message) {
      this.setState({
        status: (
          <Alert
            color="red"
            header="Aggiungi delle informazioni"
            description="Aggiungi delle informazioni per aiutarti a risolvere il problema!"
          />
        ),
      });
      this.setState({ form: <ContactComponent component={this} /> });
      return;
    }

    await fetch(
      window.location.protocol +
        "//" +
        window.location.host +
        "/passwordreset/contact",
      requestOptions
    )
      .then(async (response) => await response.json())
      .then((data) => {
        if (data.status === "UNKNOWN_USER") {
          this.setState({
            status: (
              <Alert
                color="red"
                header="Utente inesistente"
                description="Non è stato trovato nessun utente con questi dati!"
              />
            ),
          });
          return;
        }

        if (data.status === "INVALID_EMAIL") {
          this.setState({
            status: (
              <Alert
                color="red"
                header="Email invalida!"
                description="Quello inserito non è un indirizzo email valido!"
              />
            ),
          });
          return;
        }

        if (data.status === "WAIT_TIMEOUT") {
          this.setState({
            status: (
              <Alert
                color="red"
                header="Timeout di attesa"
                description="Hai già inviato una richiesta negli ultimi 10 minuti, aspetta!"
              />
            ),
          });
          return;
        }

        if (data.success === null) {
          this.setState({
            status: (
              <Alert
                color="red"
                header="Errore interno!"
                description="C'è stato un errore interno, riprova!"
              />
            ),
          });
          return;
        }

        this.setState({
          status: (
            <Alert
              color="green"
              header="Richiesta inviata"
              description={
                "Hai inviato la richiesta con successo, riceverai risposta all'indirizzo " +
                data.sentTo
              }
            />
          ),
        });
      })
      .then(() =>
        this.setState({ form: <ContactComponent component={this} /> })
      );
  }

  componentDidMount() {
    document.title = this.props.title;
    this.setState({
      form: <ResetComponent component={this} />,
    });
  }

  render() {
    return (
      <div>
        <div className="flex flex-col items-center min-h-screen pt-6 sm:justify-center sm:pt-0 bg-gray-50">
          <div>
            <h3 className="text-4xl font-bold text-green-600">
              <img
                src={LogoTecno}
                className="mx-auto h-32 w-auto"
                alt="Logo TecnoRoleplay"
              />
            </h3>
          </div>
          {this.state.form}
        </div>
      </div>
    );
  }
}
